import React, { useEffect, useState, Component } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import BillingPanel from "@/components/BillingPanel";

class BillingErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error("BillingPanel Error:", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white rounded-3xl p-8 text-center border border-red-100 shadow-sm space-y-4 max-w-lg mx-auto my-12">
          <h2 className="font-serif text-xl text-red-600">Something went wrong in Billing</h2>
          <p className="text-xs text-gray-500">{this.state.error?.message || "An unexpected error occurred."}</p>
          <button
            onClick={() => {
              this.setState({ hasError: false });
              window.location.reload();
            }}
            className="px-4 py-2 bg-eminence-gold text-white rounded-xl text-xs font-bold uppercase tracking-wider shadow-sm hover:bg-opacity-90"
          >
            Reload Billing Desk
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Billing() {
  const location = useLocation();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leads?all=true")
      .then(res => {
        setLeads(res.data || []);
      })
      .catch(() => {
        toast.error("Failed to load clients list");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F5F1] py-12 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto space-y-8">
        <div>
          <h1 className="font-serif text-3xl md:text-4xl text-gray-900">Billing Desk</h1>
          <p className="text-sm text-eminence-muted mt-1">
            Create invoices, assign packages, and process customer service records.
          </p>
        </div>

        <BillingErrorBoundary>
          {loading ? (
            <div className="bg-white rounded-3xl p-12 text-center border border-gray-100 shadow-sm animate-pulse text-eminence-muted uppercase tracking-[0.2em] text-xs">
              Loading billing system...
            </div>
          ) : (
            <BillingPanel 
              leads={leads} 
              initialClientName={location.state?.clientName || location.state?.editOrder?.full_name || location.state?.editOrder?.user_name} 
              initialContactNumber={location.state?.contactNumber || location.state?.editOrder?.phone} 
              editOrder={location.state?.editOrder}
            />
          )}
        </BillingErrorBoundary>
      </div>
    </div>
  );
}
